import { useUser } from "@clerk/clerk-react";
import { RedirectToSignIn } from "@clerk/clerk-react";
import FullPageLoader from "./FullPageLoader";

const Authentication = ({ children }: { children: React.ReactNode }) => {
	const { isSignedIn, isLoaded } = useUser();

	if (!isLoaded) {
		return <FullPageLoader />;
	}

	if (!isSignedIn) {
		return <RedirectToSignIn />;
	}

	return <>{children}</>;
};

export default Authentication;
